import { htmlNodes } from './htmlNodes';
import { patterns } from './regex';

export const generateCodeBlock = (originalContent: string) => {
  let result = originalContent;

  result = result
    .replace(
      patterns.codeBlock,
      (_m: string, _l: string, codeContent: string) =>
        htmlNodes.codeBlock(codeContent)
    )
    .replace(
      patterns.leadingAndTrailingWhitespace,
      (_m: string, codeContent: string) => htmlNodes.codeBlock(codeContent)
    );
  return result;
};
